module.exports = __webpack_public_path__ + "static/media/KartPassWhite.4d7b5291.png";